const swiper = require('./swiper').default;
const cashback = require('./cashback').default;
const messengerLicenseAgree = require('./messengerLicenseAgree').default;

module.exports = () => new Vue({
    data: {
        last: null
    },

    el: '#bar-list-wrap',

    mounted() {
        this.last = this.$el.lastElementChild

        $helpers.initTooltips(this.$el);
        $helpers.initFoodMenu(this.$el);
        $helpers.cutPhoneForClick(this.$el, 11, false);

        this.initSwiper();
        this.initDostavkaCarousel();

        if ($app.Favorite) {
            $app.Favorite.process(this.$el, '.place__favorite:not([data-initialized])');
        }

        cashback(this.$el)
        messengerLicenseAgree(this.$el)
    },

    methods: {
        initDostavkaCarousel() {
            const observer = new IntersectionObserver(([entry], observer) => {
                if (entry.isIntersecting) {
                    $.get($app.urlPrefix + '/bar/listing/dostavkaCarousel', {id: entry.target.dataset.id}, response => {
                        entry.target.innerHTML = response.data

                        swiper(entry.target.firstElementChild)

                        observer.unobserve(entry.target)
                    })
                }
            })

            this.$el.querySelectorAll('.dostavka-carousel').forEach(item => observer.observe(item))
        },

        initSwiper() {
            let swiperObserver = new IntersectionObserver(([entry], observer) => {
                if (entry.isIntersecting) {
                    let p = 2
                    let data = {
                        spaceBetween: 10,
                        breakpoints: null,
                        slidesPerView: 'auto',
                        on: {
                            reachEnd: s => {
                                let data = {
                                    p,
                                    href: entry.target.querySelector('a').href,
                                    sort: { holiday: entry.target.dataset.sortHoliday },
                                    barId: entry.target.closest('.place').dataset.id
                                }

                                $.get($app.urlPrefix + '/bar/listing/getGallerySlides', data, ({ slides }) => {
                                    p++

                                    if (slides.length) {
                                        s.appendSlide(slides)
                                    } else if (p === 3) {
                                        s.disable()

                                        s.slides[s.activeIndex].classList.add('w-100')
                                    }
                                })
                            }
                        }
                    }

                    swiper(entry.target, data)

                    observer.unobserve(entry.target)
                }
            })

            this.$el.querySelectorAll('.swiper').forEach(item => {
                if (item.classList.contains('swiper--listing')) {
                    swiperObserver.observe(item)
                } else {
                    swiper(item)
                }
            })
        },

        toPage(event, fromShowMore = false) {
            event.preventDefault()

            let [page, params] = event.currentTarget.href.split('?')
            let matchPage = params?.match(/p=(\d+)/)
            let toPage = matchPage ? matchPage[1] : 1

            $app.runEvent('click', 'from-listing.' + (fromShowMore ? 'show-more' : 'to-page-' + toPage))

            $filter.processRequest(params, undefined, params?.indexOf('subfilter') >= 0 ? page : undefined, fromShowMore)
        },

        loadBarsOfChain({target}) {
            let card = $(target).closest('.place'),
                loader = $('<img src="/data/base/img/ajax-loader.gif">');

            $(target).replaceWith(loader);

            $app.runEvent('click', { 'from-listing': target.textContent.toLowerCase() });

            $.get($app.urlPrefix + '/bar/listing/barsOfChain/' + card.data('id'), ({html}) => {
                loader.remove();

                let items = $(html);

                card.after(items);

                $helpers.initTooltips(items.show(400));
            });
        },

        getClosest() {
            new YandexMap(document.createElement('div'), $app.cityCoords, $app.ymapApiKey).then(Map => {
                Map.api.geolocation.get().then(result => {
                    let coords = result.geoObjects.get(0).geometry.getCoordinates()

                    if (coords && coords.length === 2 && coords.filter(c => c > 0).length === 2) {
                        $filter.processRequest(Object.assign($filter.getData(), { coords }))
                    } else {
                        swal.fire('Ошибка :(', 'Не удалось определить ваши координаты', 'error')
                    }
                })
            })

            return false
        }
    }
});